import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

// Procesa el #session_id= que devuelve Emergent Auth (Google) y lo canjea por nuestro JWT.
export const GoogleAuthCallback = () => {
  const { loginWithGoogleSession } = useAuth();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const params = new URLSearchParams(window.location.hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    (async () => {
      try {
        if (!sessionId) throw new Error("missing session_id");
        await loginWithGoogleSession(sessionId);
        toast.success("Sesión iniciada con Google");
        navigate("/", { replace: true });
      } catch (e) {
        toast.error(e.response?.data?.detail || "No se pudo iniciar sesión con Google");
        navigate("/login", { replace: true });
      }
    })();
  }, [loginWithGoogleSession, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background" data-testid="google-auth-callback">
      <div className="spinner w-8 h-8" />
    </div>
  );
};

export default GoogleAuthCallback;
